import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import AppSettingsService from "../services/AppSettingsService";

const useAppSettingsService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new AppSettingsService(client);
  }, [client]);

  return service;
};

export default useAppSettingsService;
